// extracted by mini-css-extract-plugin
export default {"backgroundOrgDiv":"AdminOrganization_backgroundOrgDiv__rVNnH"};